import { button, el } from '../ui/dom';

/**
 * Écran d'erreur (phase 5) : adresse inconnue ou panne irrécupérable.
 *
 * Le serveur renvoie l'application pour toute route GET inconnue (fallback
 * SPA) : c'est donc au client d'afficher un 404 propre plutôt que l'accueil,
 * sans quoi une faute de frappe dans l'URL passerait pour un fonctionnement
 * normal.
 */
export interface ErrorScreenOptions {
  readonly code: string;
  readonly title: string;
  readonly message: string;
  readonly onHome: () => void;
}

export interface ErrorScreen {
  readonly element: HTMLElement;
}

export function renderError(options: ErrorScreenOptions): ErrorScreen {
  const view = el('main', 'screen screen--error');
  view.dataset.testid = 'error-screen';
  view.dataset.code = options.code;

  const panel = el('section', 'error-panel');
  panel.append(
    el('p', 'error-panel__code', options.code),
    el('h1', 'error-panel__title', options.title),
    el('p', 'error-panel__message', options.message),
  );

  const home = button('← Retour à l’accueil', 'error-home', 'button button--primary');
  home.addEventListener('click', () => options.onHome());
  panel.append(home);

  view.append(panel);
  return { element: view };
}
